import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ShopSection() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth >= 769 && windowWidth <= 1024;

  // Product data
  const products = [
    {
      id: 1,
      name: "Whey Protein Isolate",
      price: "₹2,999",
      originalPrice: "₹3,499",
      image: "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "Protein",
      description: "Premium whey protein isolate for muscle building and recovery"
    },
    {
      id: 2,
      name: "Mass Gainer Pro",
      price: "₹3,299",
      originalPrice: "₹3,799",
      image: "https://i.pinimg.com/736x/09/9b/35/099b357445a789df528c1e5194bea820.jpg",
      category: "Weight Gainer",
      description: "High-calorie mass gainer for serious weight and muscle gain"
    },
    {
      id: 3,
      name: "BCAA Energy Drink",
      price: "₹1,799",
      originalPrice: "₹2,199",
      image: "https://i.pinimg.com/736x/86/c7/cc/86c7cc32d37cfc19a9828938549771a3.jpg",
      category: "Amino Acids",
      description: "Essential amino acids for energy and muscle recovery"
    },
    {
      id: 4,
      name: "Pre-Workout Booster",
      price: "₹2,199",
      originalPrice: "₹2,599",
      image: "https://i.pinimg.com/736x/35/f8/db/35f8db49c88b0128b1fb405303bb1a6b.jpg",
      category: "Pre-Workout",
      description: "Explosive energy and focus for intense workouts"
    },
    {
      id: 5,
      name: "Creatine Monohydrate",
      price: "₹1,499",
      originalPrice: "₹1,899",
      image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "Strength",
      description: "Pure creatine monohydrate for strength and power"
    },
    {
      id: 6,
      name: "Multivitamin Complex",
      price: "₹999",
      originalPrice: "₹1,299",
      image: "https://i.pinimg.com/736x/98/df/9a/98df9a91c497b3c50ce85c7e1e24db64.jpg",
      category: "Vitamins",
      description: "Complete daily nutrition support for active lifestyles"
    },
    {
      id: 7,
      name: "L-Glutamine Powder",
      price: "₹1,699",
      originalPrice: "₹2,099",
      image: "https://i.pinimg.com/736x/e2/b4/7e/e2b47efce408c2454de573b19b7de2dc.jpg",
      category: "Recovery",
      description: "Premium glutamine for faster muscle recovery and immune support"
    },
    {
      id: 8,
      name: "Fish Oil Omega-3",
      price: "₹1,299",
      originalPrice: "₹1,599",
      image: "https://images.unsplash.com/photo-1628771065518-0d82f1938462?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "Health",
      description: "High-quality omega-3 fatty acids for heart and brain health"
    }
  ];

  const styles = {
    shopSection: {
      padding: isMobile ? '60px 20px' : isTablet ? '80px 40px' : '100px 50px',
      backgroundColor: '#0a0a0a',
      minHeight: '100vh',
      color: 'white',
    },
    container: {
      maxWidth: '1400px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'left',
      marginBottom: isMobile ? '40px' : '60px',
      maxWidth: '1200px',
      margin: `0 auto ${isMobile ? '40px' : '60px'} auto`,
    },
    title: {
      fontSize: isMobile ? '2.5rem' : isTablet ? '3rem' : '3.5rem',
      fontWeight: 'bold',
      marginBottom: '20px',
      color: 'white',
    },
    titleHighlight: {
      color: '#54B73D',
    },
    subtitle: {
      fontSize: isMobile ? '1.1rem' : '1.3rem',
      color: '#cccccc',
      maxWidth: '700px',
      margin: '0',
      lineHeight: '1.6',
    },
    productsGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' :
        isTablet ? 'repeat(2, 1fr)' :
          'repeat(auto-fit, minmax(260px, 1fr))',
      gap: isMobile ? '2rem' : '2rem',
      marginTop: '50px',
      maxWidth: '1200px',
      margin: '50px auto 0 auto',
    },
    productCard: {
      backgroundColor: '#3D3D3D',
      borderRadius: '12px',
      overflow: 'hidden',
      transition: 'all 0.3s ease',
      border: '2px solid transparent',
      cursor: 'pointer',
      maxWidth: '350px',
      margin: '0 auto',
      width: '100%',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    },
    productImage: {
      width: '100%',
      height: '160px',
      objectFit: 'cover',
      transition: 'transform 0.3s ease',
    },
    productInfo: {
      padding: '1.5rem',
    },
    productCategory: {
      fontSize: '0.9rem',
      color: '#54B73D',
      fontWeight: '600',
      marginBottom: '8px',
      textTransform: 'uppercase',
      textAlign: 'left',
    },
    productName: {
      fontSize: '1.3rem',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: 'white',
      textAlign: 'left',
    },
    productDescription: {
      fontSize: '0.95rem',
      color: '#cccccc',
      lineHeight: '1.5',
      marginBottom: '20px',
      textAlign: 'left',
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1.1rem',
    },
    priceSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    currentPrice: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#54B73D',
    },
    originalPrice: {
      fontSize: '1.1rem',
      color: '#888888',
      textDecoration: 'line-through',
    },
    addToCartBtn: {
      backgroundColor: '#54B73D',
      color: '#000',
      border: 'none',
      padding: '0.75rem',
      borderRadius: '10px',
      fontWeight: 'bold',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      width: '100%',
      marginTop: '20px',
    },
    viewAllBtn: {
      display: 'block',
      margin: '60px auto 0',
      backgroundColor: 'transparent',
      color: '#54B73D',
      border: '2px solid #54B73D',
      padding: '15px 40px',
      borderRadius: '30px',
      fontSize: '1.1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    // Modal styles
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.95)',
      zIndex: 1000,
      overflowY: 'auto',
      animation: 'slideIn 0.3s ease-out',
    },
    modalContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: isMobile ? '60px 20px 40px' : isTablet ? '70px 30px 40px' : '80px 40px 40px',
      minHeight: '100vh',
      boxSizing: 'border-box',
      width: '100%',
    },
    modalHeader: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr auto',
      gridTemplateRows: isMobile ? 'auto auto auto' : 'auto',
      gap: '15px',
      alignItems: 'center',
      marginBottom: '20px',
      width: '100%',
    },
    modalTitle: {
      fontSize: isMobile ? '2rem' : isTablet ? '2.5rem' : '3rem',
      color: '#fff',
      fontWeight: '700',
      margin: '0 0 20px 0',
      textAlign: 'left',
      gridColumn: '1 / 3',
      gridRow: '1',
    },
    modalActions: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      alignItems: 'center',
      gap: '20px',
      width: '100%',
      gridColumn: '1 / 3',
      gridRow: '2',
    },
    searchContainer: {
      position: 'relative',
      width: '100%',
      gridColumn: '1',
    },
    searchInput: {
      background: 'rgba(255, 255, 255, 0.1)',
      border: '2px solid rgba(84, 183, 61, 0.3)',
      borderRadius: '25px',
      padding: '10px 40px 10px 16px',
      color: '#fff',
      fontSize: '0.9rem',
      width: '100%',
      transition: 'all 0.3s ease',
      boxSizing: 'border-box',
    },
    searchIcon: {
      position: 'absolute',
      right: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#ccc',
      fontSize: '1rem',
      pointerEvents: 'none',
    },
    modalTitleHighlight: {
      color: '#54B73D',
    },
    modalTitleHighlight: {
      color: '#54B73D',
    },
    closeButton: {
      background: 'none',
      border: '2px solid #54B73D',
      color: '#54B73D',
      width: isMobile ? '40px' : '50px',
      height: isMobile ? '40px' : '50px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: isMobile ? '1.2rem' : '1.5rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      flexShrink: 0,
    },
    modalGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(260px, 1fr))',
      gap: isMobile ? '1.5rem' : '2rem',
      maxWidth: '1200px',
      margin: '0 auto',
      justifyContent: 'center',
    }
  };

  const handleBuyNow = (product) => {
    console.log('Buy now:', product.name);
    // Buy now functionality here
  };

  // Filter products based on search term
  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes('') ||
    product.category.toLowerCase().includes('') ||
    product.description.toLowerCase().includes('')
  );

  // Show only first 4 products initially
  const displayedProducts = products.slice(0, 4);

  const handleCardHover = (e, isHovering) => {
    if (isHovering) {
      e.currentTarget.style.transform = 'translateY(-10px)';
      e.currentTarget.style.borderColor = '#54B73D';
      e.currentTarget.style.boxShadow = '0 20px 40px rgba(84, 183, 61, 0.15)';
    } else {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.borderColor = 'transparent';
      e.currentTarget.style.boxShadow = 'none';
    }
  };

  const handleImageHover = (e, isHovering) => {
    if (isHovering) {
      e.target.style.transform = 'scale(1.05)';
    } else {
      e.target.style.transform = 'scale(1)';
    }
  };

  const handleButtonHover = (e, isHovering) => {
    if (isHovering) {
      e.target.style.backgroundColor = '#469632';
      e.target.style.transform = 'translateY(-2px)';
    } else {
      e.target.style.backgroundColor = '#54B73D';
      e.target.style.transform = 'translateY(0)';
    }
  };

  const handleViewAllHover = (e, isHovering) => {
    if (isHovering) {
      e.target.style.backgroundColor = '#54B73D';
      e.target.style.color = '#000';
    } else {
      e.target.style.backgroundColor = 'transparent';
      e.target.style.color = '#54B73D';
    }
  };

  return (
    <>
      <div style={styles.shopSection} id="shop">
        <div style={styles.container}>
          <div style={styles.header}>
            <h1 style={styles.title}>
              Fitness <span style={styles.titleHighlight}>Shop</span>
            </h1>
            <p style={styles.subtitle}>
              Premium supplements and nutrition products to fuel your fitness journey.
              Quality guaranteed, results delivered.
            </p>
          </div>

          <div style={styles.productsGrid}>
            {displayedProducts.map((product) => (
              <div
                key={product.id}
                style={styles.productCard}
                onMouseEnter={(e) => handleCardHover(e, true)}
                onMouseLeave={(e) => handleCardHover(e, false)}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  style={styles.productImage}
                  onMouseEnter={(e) => handleImageHover(e, true)}
                  onMouseLeave={(e) => handleImageHover(e, false)}
                />
                <div style={styles.productInfo}>
                  <div style={styles.productCategory}>{product.category}</div>
                  <h3 style={styles.productName}>{product.name}</h3>
                  <p style={styles.productDescription}>{product.description}</p>

                  <div style={styles.priceContainer}>
                    <div style={styles.priceSection}>
                      <span style={styles.currentPrice}>{product.price}</span>
                      <span style={styles.originalPrice}>{product.originalPrice}</span>
                    </div>
                  </div>

                  <button
                    style={styles.addToCartBtn}
                    onClick={() => handleBuyNow(product)}
                    onMouseEnter={(e) => handleButtonHover(e, true)}
                    onMouseLeave={(e) => handleButtonHover(e, false)}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ))}
          </div>

          {!false && (
            <button
              style={styles.viewAllBtn}
              onClick={() => navigate('/shop')}
              onMouseEnter={(e) => handleViewAllHover(e, true)}
              onMouseLeave={(e) => handleViewAllHover(e, false)}
            >
              View All Products
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default ShopSection;
